export { TripItinerary } from './src/TripItinerary';
export type { ItineraryGroup, TripItineraryProps } from './src/TripItinerary.types';
export {
  computeTotalCarbonFootprint,
  getOriginLocationName,
  transformItineraryForAccommodationStays,
  transformItineraryForOverview,
  transformItineraryForTransportLegs
} from './src/transformItinerary';
